<template>
  <div id="app">
    <div class="top_box">
      <!-- <div class="apply_btn" @click="linkto()">上传参赛课程</div> -->
      <div class="apply_btn" @click="linkto100()">查看100部入围决赛的课程</div>
    </div>
    <div class="center_box">
      <div class="nav_box">
        <div 
        v-for="(item,index) in this.menuData"
        :key="index"
        :class="{act : ( isActive == item.value ? true : false ) }"
        @click="isActive=item.value;currentComp=item.comp"
        >
        {{item.name}}
        </div>
        
      </div>
      <div class="center_nr_box">
        <introduce :is="currentComp"></introduce>
      </div>
      <div class="bottom"></div>
      <!-- <router-view></router-view> -->
    </div>
  </div>
</template>


<script type="text/ecmascript-6">
import Vue from "vue";
import API from "./api";
import axios from "axios";
import introduce from '../src/components/introduce.vue';
import vote from '../src/components/vote.vue';
import rank from '../src/components/rank.vue';
import {menu} from "./common/js/data";
export default {
  name: 'app',
  components: {
    introduce,
    vote,
    rank,
  },
  data() {
    return {
      username: "",
      bannerData:{},
      typeData:{},
      defaultDate:[],
      examDate:{},
      baseUrl: '',
       // 当前选中的组件
      currentComp: 'vote',
      // 当前选中的li标签
      isActive: '2',
      menuData: menu
    };
  },
  computed: {
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') {
      this.baseUrl = 'http://www.yooc.test';
      this.$cookies.set('sessionid', '4b27961d53ee3d34828ecec181fa99e4')
    } else {
      // 测试环境
      if (process.env.type === 'test') {
        this.baseUrl = 'http://www.yooc.test';
        // 正式环境
      } else {
        this.baseUrl = 'https://www.yooc.me';
      }
    };
  },
  
  methods: {
    async linkto(){
      // console.log(1)
      var URL =this.Host+'/upload/check'
      await this.$axios.get(URL)
      .then((res)=>{
        var code = res.data.code
        if(code==404){
          window.location.href="/login"; 
          
        }else if(code==403){
          this.$message.error(res.data.message);
        }else{
          window.open("/dashboard/course/edit?origin=youke2024"); 
        }
        
        // this.rankdata=res.data.data.courses;
        console.log(res.result);
      }).catch((error)=>{
        console.error(error);
      }) 
      // window.open("https://www.yooc.me/youke2024/result100"); 
    },
    async linkto100(){
     
      window.open("https://www.yooc.me/youke2024/result100"); 
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/stylus" type="text/stylus" scoped>

  #app{
    font-family: 'Avenir', Helvetica, Arial, sans-serif
    -webkit-font-smoothing antialiased
    -moz-osx-font-smoothing grayscale
    -webkit-font-smoothing antialiased;
   width: 100%;
   min-width: 1105px;
   background: url('../src/assets/images/top_bg.png') center 0 no-repeat;
  }
  .top_box{
    width: 1105px;
    margin: 0 auto;
    height: 530px;
    position: relative;
    .apply_btn{
      width: 272px;
      height: 52px;
      background: url('../src/assets/images/apply_btn.png');
      display: block;
      position: absolute;
      left: 50%;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
      top: 385px;
      cursor: pointer;
      font-size: 18px;
      font-weight: bold;
      color: #fff;
      text-align: center;
      line-height: 47px;
    }
  }
  .center_box{
    width: 1105px;
    margin: 0 auto;
    margin-top: -75px;
    position: relative;
    z-index: 1;
    .nav_box{
      height: 67px;
      width: 100%;
      margin-top: 20px;
      display: flex;
      justify-content: center;
      div{
        cursor: pointer;
        width: 236px;
        height: 67px;
        text-align: center;
        line-height: 67px;
        font-size: 20px;
        font-weight: bold;
        color: #F97B58;
        float: left;
        background-image: url('../src/assets/images/nav_bg.png');
        margin: 0 15px;
      }
      .act{
        width: 236px;
        height: 67px;
        line-height: 67px;
        background-image: url('../src/assets/images/nav_bg_hover.png');
      }
    }
    .center_nr_box{
     margin-top: 40px;
    }
    .bottom{
      height: 80px;
    }
  }
  
</style>



// WEBPACK FOOTER //
// App.vue?48567212